package pwgs.ui.scenes.diagnosticserrorgroupsscene

import kotlinx.serialization.Serializable
import visage.rmi.VisageController

@VisageController(DiagnosticsErrorGroupsSceneProps::class, DiagnosticsErrorGroupsSceneModel::class)
interface DiagnosticsErrorGroups {
    fun load()
}

@Serializable
data class DiagnosticsErrorGroupsSceneProps(
    val projectId: Long,
    val orderBy: String
)

@Serializable
class DiagnosticsErrorGroupsSceneModel(
    val items: List<DiagnosticsErrorGroupItemModel>
) {
    var isLoading = true
}

@Serializable
class DiagnosticsErrorGroupItemModel(
    val id: String,
    val content: String,
    val firstSeenAt: Long,
    val lastSeenAt: Long,
    val issueCount: Long
)